var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chip-demo"}},[_c('chip-default'),_c('chip-color'),_c('chip-icon'),_c('chip-closable'),_c('chip-add-remove'),_c('chip-customize-close-clear-chip-icon')],1)}
var staticRenderFns = []

export { render, staticRenderFns }